import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Create Enterprise';
const SITE_URL = 'https://createenterprise.in';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

/**
 * Per-page <title>/meta tags. Without this every route shared the same
 * generic "Create enterprise" title/description from public/index.html,
 * which is why only pages Google indexed by other signals (like About Us)
 * ranked — the rest were indistinguishable to search engines.
 */
export default function Seo({ title, description, path = '', image, noindex = false, jsonLd }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Premium Products, Supplements & Wellness`;
  const canonical = `${SITE_URL}${path}`;
  const desc = description || 'Create Enterprise — premium products, supplements & wellness. Wholesale, private label and export solutions.';

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image || DEFAULT_IMAGE} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image || DEFAULT_IMAGE} />

      {jsonLd && (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((block, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(block)}</script>
      ))}
    </Helmet>
  );
}
